import { Box, Button, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, Modal, Select, Typography } from "@mui/material";
import { useGetClassAndSubjectTeacherQuery, useGetLessonSessionsQuery } from "../../../api/lessonNoteApi";
import { SetUpTable } from "./SetUpTable";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useState } from "react";
import { style } from "../../../styles/styles";
import api from "../../../services/QualityAssurance";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { TableReviewSheet } from "./TimeTableReviewSheet";

export const TimeTable = () => {
    const [tab, setTab] = useState(0);
    const handleOpenModal = () => setOpenModal(true);
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const { admToken, user } = useSelector((state) => state.auth);

    const [selectedSession, setSelectedSession] = useState({
        sessionId: 0,
        sessionName: ''
    });

    const [selectedClasses, setSelectedClasses] = useState({
        classId: 0,
        className: ''
    });

    const { data: sessions, isLoading: sessionsLoading } = useGetLessonSessionsQuery();
    const { data: classAndArm, isLoading } = useGetClassAndSubjectTeacherQuery(user ? user.schoolId : 0);

    const handleCloseModal = () => {
        setOpenModal(false)
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const selectedSession = sessions?.data?.find(s => s.id === value);
        setSelectedSession(prev => ({
            ...prev,
            [name]: value,
            sessionName: selectedSession ? selectedSession.name : ''
        }));
    };

    const handleChangeClass = (e) => {
        const { name, value } = e.target;
        const selectedClass = classAndArm?.data?.find(s => s.id === value);
        setSelectedClasses(prev => ({
            ...prev,
            [name]: value,
            className: selectedClass ? selectedClass.name : ''
        }));
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const payload = {
                sessionId: selectedSession.sessionId,
                classId: selectedClasses.classId,
            }
            const res = await api.createTimeTableSetup(admToken, payload);
            if (res.status && res.statusCode === 2) {
                toast.success(res.data.message);
            } else {
                toast.error(res.data.message);
            }
            handleCloseModal();
        } catch (error) {
            console.error("Error creating TimeTable:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="flex flex-col lg:flex-row mb-5 items-center px-3 py-2 cursor-pointer gap-10 rounded-lg bg-[#691e78]/40 max-w-sm">
                <div
                    className={
                        tab === 0 ? "bg-white px-5 py-3 rounded-lg ring-1 ring-black text-nowrap" : ""
                    }
                    onClick={() => setTab(0)}
                >
                    <p>Timetable Setup</p>
                </div>
                <div
                    className={
                        tab === 1 ? "bg-white px-5 py-3 rounded-lg ring-1 ring-black text-nowrap" : ""
                    }
                    onClick={() => setTab(1)}
                >
                    <p>Timetable Review</p>
                </div>
            </div>

            {tab === 0 && (
                <div>
                    <div className="flex justify-between mb-5">
                        <div className="text-[20px] font-700">Timetable Setup</div>
                        <div
                            className="w-[300px] cursor-pointer items-center text-white bg-[#691e78] hover:bg-[#691e78]/90 flex justify-center px-5 py-3 rounded-lg"
                            onClick={handleOpenModal}
                        >
                            Add Timetable
                        </div>
                    </div>
                    <div>
                        <SetUpTable />
                    </div>
                    <Modal
                        open={openModal}
                        onClose={handleCloseModal}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                            <Box align="right" sx={{}}>
                                <IconButton onClick={handleCloseModal}>
                                    <HighlightOffIcon />
                                </IconButton>
                            </Box>
                            <Box>
                                <Typography
                                    variant="h4"
                                    sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}
                                >
                                    Add Timetable
                                </Typography>
                                <Divider />
                            </Box>
                            <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
                                <Grid container spacing={2}>
                                    <Grid item sm={6} xs={12}>
                                        <Box>
                                            <InputLabel
                                                sx={{
                                                    mb: 1.5,
                                                    mt: 1,
                                                    fontSize: "12px",
                                                    fontWeight: "bolder",
                                                    color: "#000",
                                                    fontFamily: "Gilroy-Medium",
                                                }}
                                            >
                                                School Year
                                            </InputLabel>
                                            <FormControl fullWidth>
                                                <Select
                                                    name="sessionId"
                                                    sx={{
                                                        fontFamily: "Gilroy-Regular",
                                                        border: "0.5px solid #fff",
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                border: "1px solid #fff",
                                                            },
                                                        },
                                                    }}
                                                    variant="outlined"
                                                    size="small"
                                                    value={selectedSession.sessionId}
                                                    onChange={handleChange}
                                                    disabled={sessionsLoading}
                                                >
                                                    {sessionsLoading ? (
                                                        <MenuItem disabled>Loading session...</MenuItem>
                                                    ) : !sessions?.data || sessions.data.length === 0 ? (
                                                        <MenuItem disabled>No session available</MenuItem>
                                                    ) : (
                                                        sessions.data.map((session) => (
                                                            <MenuItem
                                                                sx={{ fontFamily: "Gilroy-Regular" }}
                                                                value={session.id}
                                                                key={session.id}
                                                            >
                                                                {session.name}
                                                            </MenuItem>
                                                        ))
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                    <Grid item sm={6} xs={12}>
                                        <Box>
                                            <InputLabel
                                                sx={{
                                                    mb: 1.5,
                                                    mt: 1,
                                                    fontSize: "12px",
                                                    fontWeight: "bolder",
                                                    color: "#000",
                                                    fontFamily: "Gilroy-Medium",
                                                }}
                                            >
                                                Class
                                            </InputLabel>
                                            <FormControl fullWidth>
                                                <Select
                                                    name="classId"
                                                    sx={{
                                                        fontFamily: "Gilroy-Regular",
                                                        border: "0.5px solid #fff",
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                border: "1px solid #fff",
                                                            },
                                                        },
                                                    }}
                                                    variant="outlined"
                                                    size="small"
                                                    value={selectedClasses.classId}
                                                    onChange={handleChangeClass}
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? (
                                                        <MenuItem disabled>Loading class...</MenuItem>
                                                    ) : !classAndArm?.data || classAndArm.data.length === 0 ? (
                                                        <MenuItem disabled>No session available</MenuItem>
                                                    ) : (
                                                        classAndArm.data.map((item) => (
                                                            <MenuItem
                                                                sx={{ fontFamily: "Gilroy-Regular" }}
                                                                value={item.classId}
                                                                key={item.classId}
                                                            >
                                                                {item.className} {item.classArm}
                                                            </MenuItem>
                                                        ))
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Box mt={10}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        sx={{ textTransform: "initial", backgroundColor: "#691e78" }}
                                        onClick={handleSubmit}
                                        disabled={loading}
                                    >
                                        {loading ? "Adding..." : "Add TimeTable"}
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Modal>
                </div>
            )}

            {tab === 1 && (
                <div>
                    <TableReviewSheet />
                </div>
            )}
        </>
    );
};
